import { TResponseDataToOptions } from './_types';

export const transformResponseDataToOptions = (
  data: Array<string>,
): Array<TResponseDataToOptions> => {
  return data.map((item, index) => {
    const id = index + 1;

    return {
      id: id.toString(),
      subLabel: item,
    };
  });
};
